import { render, staticRenderFns } from "./docemployee.vue?vue&type=template&id=b5bc97f2&scoped=true&"
import script from "./docemployee.vue?vue&type=script&lang=js&"
export * from "./docemployee.vue?vue&type=script&lang=js&"
import style0 from "./docemployee.vue?vue&type=style&index=0&id=b5bc97f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bc97f2",
  null
  
)

export default component.exports